import React from "react";

type PlanSummary = {
  id: string;
  name: string;
  type: "workout" | "food";
};

interface Props {
  plans: PlanSummary[];
  onExpand: (plan: PlanSummary) => void;
  expandedId?: string;
}

const AssignedPlansList: React.FC<Props> = ({
  plans,
  onExpand,
  expandedId,
}) => {
  if (!plans || plans.length === 0) {
    return null;
  }
  return (
    <div className="assigned-plans-list">
      {plans.map((p) => (
        <div
          key={p.id}
          className="plan-item"
          aria-expanded={expandedId === p.id}
        >
          <div className="plan-item-header">
            <span className="plan-type" data-type={p.type}>
              {p.type === "workout" ? "Workout" : "Food"}
            </span>
            <span className="plan-name">{p.name}</span>
          </div>
          <button className="expand-btn" onClick={() => onExpand(p)}>
            View
          </button>
        </div>
      ))}
    </div>
  );
};

export default AssignedPlansList;
